import { PropType, defineComponent, h } from 'vue';
import { Dialog, utility } from '@phi/components';
import FormSelect, { Entry } from '../FormSelect';
import { Length } from '../../Units';
import FormToggle from '../FormToggle';
import { SelectDocumentElement } from '@components/OnshapeExplorer';
import { State } from '../../state';
import { BlobElement } from '@phi/onshape';
import { Option } from '@vaaas/fpts/option';
import { loadRefSTLOnshape } from '../../input_output';
import { Label } from '@components/form';
import { rem } from '@phi/util/css';

const FormSelectLength = FormSelect<Length>();

const options: Array<Entry<Length>> = [
    { value: Length.cm, text: 'Centimeter' },
    { value: Length.ft, text: 'Foot' },
    { value: Length.in, text: 'Inch' },
    { value: Length.m, text: 'Meter' },
    { value: Length.mm, text: 'Millimeter' },
    { value: Length.yd, text: 'Yard' },
];

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
        state: { required: true, type: Object as PropType<State> },
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    data() {
        return {
            unit: this.state.display_units,
            y_axis_up: false,
            stl: undefined as Option<BlobElement>,
            had_selected_document: this.state.document !== undefined,
        };
    },

    watch: {
        show(value) {
            if (value)
                this.reset();
        },
    },

    methods: {
        reset() {
            this.unit = this.state.display_units;
            this.y_axis_up = false;
            this.stl = undefined;
            this.had_selected_document = this.state.document !== undefined;
        },

        onCancel() {
            this.$emit('update:show', false);
        },

        onConfirm() {
            loadRefSTLOnshape(
                this.stl!.id,
                this.state.document!,
                this.state.workspace!,
                this.unit,
                this.y_axis_up,
            );
            this.$emit('update:show', false);
        },
    },

    render() {
        return h(Dialog, {
            show: this.show,
            id: 'ImportRefStlModelModal',
            title: 'Import reference STL model',
            close_label: 'Cancel',
            onClose: this.onCancel,
            confirm_label: 'Import',
            onConfirm: this.onConfirm,
            width: 'narrow',
            'onUpdate:show': x => this.$emit('update:show', x),
        }, () => h('div', { class: utility.margin_gap_3 }, [
            h('div', {
                class: utility.overflow,
                style: { maxHeight: rem(20) },
            }, h(SelectDocumentElement, {
                document: this.state.document,
                workspace: this.state.workspace,
                element: this.stl,
                elementFilter: x => x.elementType === 'BLOB' && x.dataType === 'application/stl',
                can_select_document: !this.had_selected_document,
                sub_heading: false,
                placeholder: 'Search for a reference STL file to load',
                'onUpdate:element': x => this.stl = x as BlobElement,
                'onUpdate:document': x => this.state.document = x,
                'onUpdate:workspace': x => this.state.workspace = x,
            })),

            h(FormSelectLength, {
                options: options,
                value: this.unit,
                'onUpdate:value': x => this.unit = x,
            }),

            h(Label, { space: 'between' }, {
                label: () => 'Orient reference model with Y axis up',
                input: () => h(FormToggle, {
                    value: this.y_axis_up,
                    'onUpdate:value': x => this.y_axis_up = x,
                }),
            }),
        ]));
    },
});
